import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TriviaComponent } from './trivia/trivia.component';
import { SocketService } from './shared/services/socket.service';
import { PageLoginComponent } from './page-login/page-login.component';
import { CookieService } from 'ngx-cookie-service';
import { PageTriviaHostComponent } from './page-trivia-host/page-trivia-host.component';
import { HttpClientModule } from '@angular/common/http';
import { PageHomeComponent } from './page-home/page-home.component';
import { TelestrationsComponent } from './telestrations/telestrations.component';
import { GameComponent } from './game/game.component';
import { PageTelestrationsHostComponent } from './page-telestrations-host/page-telestrations-host.component';
import { GameHostComponent } from './game-host/game-host.component';
import { DrawingPadComponent } from './drawing-pad/drawing-pad.component';
import { TriviaHostLoginResolver } from './shared/resolvers/trivia-host-login-resolver';
import { TelestrationsHostLoginResolver } from './shared/resolvers/telestrations-host-login-resolver';
import { LiarsDiceComponent } from './liars-dice/liars-dice.component';
import { PageLiarsDiceHostComponent } from './page-liars-dice-host/page-liars-dice-host.component';
import { LiarsDiceHostLoginResolver } from './shared/resolvers/liars-dice-host-login-resolver';
import { TimerComponent } from './timer/timer.component';
import { MaterialModule } from './shared/material.module';
import { GameRulesDialogComponent } from './game-rules-dialog/game-rules-dialog.component';
import { LiarsDiceRulesComponent } from './game-rules-dialog/rules-pages/liars-dice-rules/liars-dice-rules.component';
import { TelestrationRulesComponent } from './game-rules-dialog/rules-pages/telestration-rules/telestration-rules.component';
import { TriviaRulesComponent } from './game-rules-dialog/rules-pages/trivia-rules/trivia-rules.component';
import { PageScattergoriesHostComponent } from './page-scattergories-host/page-scattergories-host.component';
import { ScattergoriesComponent } from './scattergories/scattergories.component';
import { ScattergoriesHostLoginResolver } from './shared/resolvers/scattergories-host-login-resolver';
import { WindowsService } from './shared/services/windows.service';
import { PageHomeRouterComponent } from './page-home-router/page-home-router.component';
import { ScattergoriesRulesComponent } from './game-rules-dialog/rules-pages/scattergories-rules/scattergories-rules.component';

@NgModule({
  declarations: [
    AppComponent,
    TriviaComponent,
    PageLoginComponent,
    PageTriviaHostComponent,
    PageHomeComponent,
    TelestrationsComponent,
    GameComponent,
    PageTelestrationsHostComponent,
    GameHostComponent,
    DrawingPadComponent,
    LiarsDiceComponent,
    PageLiarsDiceHostComponent,
    TimerComponent,
    GameRulesDialogComponent,
    LiarsDiceRulesComponent,
    TelestrationRulesComponent,
    TriviaRulesComponent,
    PageScattergoriesHostComponent,
    ScattergoriesComponent,
    PageHomeRouterComponent,
    ScattergoriesRulesComponent
  ],
  entryComponents: [GameRulesDialogComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  providers: [
    CookieService,
    SocketService,
    WindowsService,
    LiarsDiceHostLoginResolver,
    TriviaHostLoginResolver,
    TelestrationsHostLoginResolver,
    ScattergoriesHostLoginResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
